import { Component, OnInit, Renderer2 } from "@angular/core";
import { ERTUserService } from "../../../services/ert-user/ert-user.service";
import { Router } from "@angular/router";
import { ERTUser } from "../../../interfaces/ert-user/ert-user";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ertUserSizes } from "../../../interfaces/ert-user/ert-user-sizes";
import { PicklistItem } from "../../../shared/picklist/picklist-select.component";
import { IPicklistValuesData } from "../../../interfaces/administration/picklistValuesData";
import { LoggedUserService } from "../../../services/common/logged-user.service";
import { ILoggedUserData } from "../../../interfaces/common/loggedUserData";
@Component({
  selector: "app-ert-new-user-details",
  templateUrl: "./ert-new-user-details.component.html",
  styleUrl: "./ert-new-user-details.component.css",
})
export class ErtNewUserDetailsComponent implements OnInit {
  userForm: FormGroup;
  isAddingUsers: boolean = false;
  validationMessages: string[] = [];
  errorMessage: string[] = [];
  sizes = Object.entries(ertUserSizes)
    .filter(([key]) => isNaN(Number(key)))
    .map(([key, value]) => ({
      label: key,
      value: value,
    }));
  selectedTeeShirtSize: string = "-- None --";
  selectedCoatSize: string = "-- None --";
  selectedHatSize: string = "-- None --";
  selectedGlovesSize: string = "-- None --";
  selectedGlassesSize: string = "-- None --";
  selectedTurnoutJacketSize: string = "-- None --";
  selectedTurnoutPantsSize: string = "-- None --";
  selectedCrewItem!: PicklistItem;
  selectedTitleItem!: PicklistItem;

  currentLoggedInUser: ILoggedUserData;

  constructor(
    private userService: ERTUserService,
    private router: Router,
    private fb: FormBuilder,
    private renderer: Renderer2,
    private loggedInUserService: LoggedUserService
  ) {}

  ngOnInit(): void {
    this.userForm = this.fb.group({
      cai_email: [""],
      lastName: ["", Validators.required],
      firstName: ["", Validators.required],
      phone: [""],
      altPhone: [""],
      hireDate: [""],
      ertDate: [""],
      mgcccNumber: [""],
      teeShirtSize: [""],
      coatSize: [""],
      hatSize: [""],
      glovesSize: [""],
      glassesSize: [""],
      turnoutJacketSize: [""],
      turnoutPantsSize: [""],
      comments: [""],
      boot: [""],
      turnoutBoot: [""],
      crew: [""],
      title: [""],
      isHurricaneWatch: [false],
      isHotWorkEntry: [false],
      isInstructor: [false],
      isTurnoverAccess: [false],
      isCompletedFCE: [false],
      calledBy: [""],
    });

    this.subscribeToSizeChanges();
    this.loggedInUserService.getLoggedUserData().subscribe((user) => {
      this.currentLoggedInUser = user;
    });
  }

  private subscribeToSizeChanges() {
    this.userForm.get("teeShirtSize").valueChanges.subscribe((value) => {
      this.selectedTeeShirtSize = value;
    });
    this.userForm.get("coatSize").valueChanges.subscribe((value) => {
      this.selectedCoatSize = value;
    });
    this.userForm.get("hatSize").valueChanges.subscribe((value) => {
      this.selectedHatSize = value;
    });
    this.userForm.get("glovesSize").valueChanges.subscribe((value) => {
      this.selectedGlovesSize = value;
    });
    this.userForm.get("glassesSize").valueChanges.subscribe((value) => {
      this.selectedGlassesSize = value;
    });
    this.userForm.get("turnoutJacketSize").valueChanges.subscribe((value) => {
      this.selectedTurnoutJacketSize = value;
    });
    this.userForm.get("turnoutPantsSize").valueChanges.subscribe((value) => {
      this.selectedTurnoutPantsSize = value;
    });
  }

  addUser() {
    this.validationMessages = this.userService.validateNewErtUserStep2(
      this.userForm
    );
    if (this.validationMessages.length > 0) {
      this.errorMessage = [];
      this.scrollToTop();
      return;
    }
    this.validationMessages = [];
    this.isAddingUsers = true;

    const hireDateValue = this.userForm.get("hireDate").value;
    const ertDateValue = this.userForm.get("ertDate").value;
    const crewValue = this.userForm.get("crew")?.value;
    const titleValue = this.userForm.get("title")?.value;

    const crew: IPicklistValuesData = {
      id: crewValue || 0,
      value: this.selectedCrewItem?.text,
      picklistFieldId: this.selectedCrewItem?.fieldId,
      facilityId: 1,
    };

    const title: IPicklistValuesData = {
      id: titleValue || 0,
      value: this.selectedTitleItem?.text,
      picklistFieldId: this.selectedTitleItem?.fieldId,
      facilityId: 1,
    };
    this.userService.setERTUser(<ERTUser>{
      facilityId: Number(this.currentLoggedInUser?.facilityId) || 1,
      firstName: this.userForm.get("firstName").value,
      lastName: this.userForm.get("lastName").value,
      fullName: `${this.userForm.get("firstName").value} ${
        this.userForm.get("lastName").value
      }`,
      caiEmail: this.userForm.get("cai_email").value,
      phone: this.userForm.get("phone").value.toString(),
      altPhone: this.userForm.get("altPhone").value.toString(),
      hireDate: new Date(hireDateValue),
      mgcccNumber: this.userForm.get("mgcccNumber").value,
      ertDate: new Date(ertDateValue),
      comments: this.userForm.get("comments").value,
      teeShirtSize: this.selectedTeeShirtSize,
      coatSize: this.selectedCoatSize,
      hatSize: this.selectedHatSize,
      glovesSize: this.selectedGlovesSize,
      glassesSize: this.selectedGlassesSize,
      turnoutJacketSize: this.selectedTurnoutJacketSize,
      turnoutPantsSize: this.selectedTurnoutPantsSize,
      boot: this.userForm.get("boot").value,
      turnoutBoot: this.userForm.get("turnoutBoot").value,
      crewId: crewValue || 0,
      titleId: titleValue || 0,
      picklistValues: [crew, title],
      isHurricaneWatch: this.userForm.get("isHurricaneWatch").value,
      isHotWorkEntry: this.userForm.get("isHotWorkEntry").value,
      isInstructor: this.userForm.get("isInstructor").value,
      isTurnoverAccess: this.userForm.get("isTurnoverAccess").value,
      isCompletedFCE: this.userForm.get("isCompletedFCE").value,
      calledBy: this.userForm.get("calledBy").value,
      createdById: this.currentLoggedInUser?.id,
    });
    this.userService.addERTUser().subscribe({
      next: (data) => {
        if (data) {
          this.isAddingUsers = false;
          this.userService.newERTUser = <ERTUser>{};
          this.router.navigateByUrl("/ert-user");
        }
      },
      error: (error) => {
        this.isAddingUsers = false;
        this.errorMessage.push(error.error);
        this.scrollToTop();
      },
    });
  }

  private scrollToTop() {
    this.renderer.setProperty(document.documentElement, "scrollTop", 0);
    this.renderer.setProperty(document.body, "scrollTop", 0);
  }

  onCrewSelected(item: PicklistItem) {
    this.selectedCrewItem = item;
  }

  onTitleSelected(item: PicklistItem) {
    this.selectedTitleItem = item;
  }
}
